import { FlowTransitionsContext, IFlowTransitionsContext } from '@app/context/FlowTransitionsContext';
import { createUseProvidedContext } from '@stenngroup/utilities';

export const useFlowTransitionsContext = createUseProvidedContext<IFlowTransitionsContext>(
  FlowTransitionsContext,
  'FlowTransitionsContext'
);
